<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import config from '../../.././../../../configHttp';
import minhead from '../../../../common/minHead/index.vue';
import {
    stampdetailsquery,
    stampdetailsshuimquery,
    suosqbetweenquery,
    detailsadd,
    detailsupdate,
    detailssinglequery,
    detailsdelete,
    sysYhsSm,
    taxyhs,
    getCompanyByNsrsbh
} from '../../../../../api/yhs.js';
import { comMapping } from '@/components/util/Function/comMapping';
export default {
    name: '',
    components: {
        minhead
    },
    props: {
        mxparams: {
            type: Object,
            default: () => ({})
        }
    },
    data: function () {
        return {
            tablekey: 0,
            overlength: 0,
            headData: getdata().headData,
            searchlist: getdata().searchlist,
            searchdata: getdata().searchdata,
            suosq: this.mxparams.suosq,
            biaosj: [
                {
                    nsrmc: this.mxparams.nsrmc,
                    nsrsbh: this.mxparams.nsrsbh,
                    companyNo: this.mxparams.companyNo
                }
            ],
            tableData: [],
            formlist: getdata().formlist,
            formdata: getdata().formdata,
            updatediag: false,
            headDatadiag: getdata().headDatadiag,
            tableDatadiag: [],
            sjdiag: false,
            headDatasj: getdata().headDatasj,
            tableDatasj: [],
            sbtitle: '按季申报',
            choosesb: null,
            sbdiag: false,
            headDatasb: getdata().headDatasb,
            tableDatasb: [],
            total: 0,
            delDfslIds: [],
            delJsxxIds: [],

            updateyhsdiag: false,
            pagination: getdata().pagination,
            headDatayhs: getdata().headDatayhs,
            tableDatayhs: [],
            choosedjindex: null,
            listou: {
                radio: '',
                id: ''
            },
            yhs: [
                [],
                [
                    {
                        name: '年度',
                        id: '4'
                    },
                    {
                        name: '季度',
                        id: '2'
                    }
                ]
            ],
            zimlist: [],
            shuimulist: comMapping.$smzm,
            searchdiag: false
        };
    },
    mounted() {
        this.shuimulist.forEach((item) => {
            this.zimlist = [...this.zimlist, ...item.zszm];
        });
        if (config.company == 'hls') {
            this.formlist.map((item) => {
                if (item.label == '税款所属期止' || item.label == '税款所属期起') {
                    item.disabled = false;
                }
            });
        }
    },
    created() {
        this.stampdetailsquery();
        this.CompanyByNsrsbh();
        this.shuim();
    },
    methods: {
        //表格选中计算合计
        selectionchange(e){
            let num = 0
            e.map(item=>{
             num +=  item.shijjsje
            })
            this.total = num
        },
        shuim() {
            sysYhsSm().then((res) => {
                let list = [];
                res.data.data.map((item) => {
                    list.push({
                        value: item.zspmDm,
                        label: item.zspmMc,
                        children: [...item.zszm]
                    });
                });
                this.searchlist.map((item) => {
                    if (item.label == '税目') {
                        item.selectval = [...list];
                    }
                });
                let a = this.searchlist;
                this.searchlist = JSON.parse(JSON.stringify(a));
            });
        },
        selectchanges(e) {
            let list = [];
            this.searchdata.zim = '';
            this.searchlist.map((item) => {
                if (item.label == '税目') {
                    item.selectval.map((item1) => {
                        if (e.value == item1.value) {
                            item1.children.map((item2) => {
                                list.push({
                                    value: item2.zszmDm,
                                    label: item2.zszmMc
                                });
                            });
                        }
                    });
                }
            });
            this.searchlist.map((item) => {
                if (item.label == '子目') {
                    item.selectval = [...list];
                }
            });
            let a = this.searchlist;
            this.searchlist = JSON.parse(JSON.stringify(a));
        },
        geOoverLength(e) {
            this.overlength = e;
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.stampdetailsquery();
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.stampdetailsquery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.stampdetailsquery();
        },
        forUpdateSearch() {
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.searchdiag = false;
        },
        forchoosemove(index) {
            if (this.choosedjindex != index) {
                this.choosedjindex = index;
            }
        },
        foraddup(index) {
            let item = {};
            this.tableDatayhs.splice(index, 0, item);
        },
        foradddown(index) {
            let item = {};
            this.tableDatayhs.splice(index + 1, 0, item);
        },
        forremove(item, index) {
            if (this.tableDatayhs.length == 1) {
                this.tableDatayhs = [{}];
            } else {
                this.tableDatayhs.splice(index, 1);
            }
        },
        CompanyByNsrsbh() {
            let params = {
                nsrsbh: this.mxparams.nsrsbh
            };
            getCompanyByNsrsbh(params).then((res) => {
                if (res.data.code == 1) {
                    this.listou.id = res.data.data.id;
                } else {
                    this.$message, error(res.data.msg);
                }
            });
        },
        nextnew() {
            let yhsDetailCompanys = [];
            this.tableDatayhs.map((item) => {
                if (JSON.stringify(item) !== '{}') {
                    yhsDetailCompanys.push({
                        shuil: item.shuil.split('%')[0],
                        shuim: item.shuim,
                        shuimName: item.shuimName,
                        shenbqxlx: item.shenbqxlx,
                        zim: item.zim,
                        zimName: item.zimName
                    });
                }
            });
            let yhs = false;
            yhsDetailCompanys.map((item) => {
                delete item.sfzim;
                Object.keys(item).map((key) => {
                    if ((key != 'zim' && key != 'zimName' && item[key] == '') || item[key] == null) {
                        yhs = true;
                    }
                });
            });
            if (yhsDetailCompanys.length == 0 || yhs) {
                return this.$message.error('请把信息补充完整');
            }
            let params = {
                companyId: this.listou.id,
                shifbs: this.listou.radio,
                shuiBid: 9,
                yhsDetailCompanys
            };
            edityhs(params).then((res) => {
                if (res.data.code == 1) {
                    this.updateyhsdiag = false;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },

        options(e) {
            this.tableDatayhs[e.index].option.map((item, index) => {
                if (item.zszmDm == this.tableDatayhs[e.index].zim) {
                    this.tableDatayhs[e.index].zimName = item.zszmMc;
                    this.tableDatayhs[e.index].shuil = item.sl1;
                }
            });
            this.$forceUpdate();
        },
        option(e) {
            e.zim = '';
            e.zimName = '';
            this.yhs[0].map((item) => {
                if (item.zspmDm == this.tableDatayhs[e.index].shuim) {
                    this.tableDatayhs[e.index].option = [];
                    this.tableDatayhs[e.index].shuimName = item.zspmMc;
                    if (item.zszm.length != 0) {
                        item.zszm.map((item2) => {
                            this.tableDatayhs[e.index].option.push(item2);
                        });
                    } else {
                        this.tableDatayhs[e.index].shuil = item.sl1;
                        this.tableDatayhs[e.index].sfzim = true;
                    }
                }
            });
        },
        yhsout() {
            let params = {
                companyId: 119,
                shuiBid: 9,
                shuiBNameCode: 'yhs'
            };
            sysYhsSm().then((res) => {
                if (res.data.code == 1) {
                    this.yhs[0] = res.data.data;
                    taxyhs(params).then((res) => {
                        if (res.data.code == 1) {
                            this.listou.radio = res.data.data.shifbs;
                            this.tableDatayhs = res.data.data.yhsDetailCompanys;
                            this.tableDatayhs.map((item) => {
                                this.yhs[0].map((item2) => {
                                    if (item.shuim == item2.zspmDm) {
                                        item.shuil = item.shuil;
                                        item.option = [];
                                        if (item2.zszm.length != 0) {
                                            item2.zszm.map((item3) => {
                                                item.option.push(item3);
                                            });
                                        }
                                    }
                                });
                            });
                            this.updateyhsdiag = true;
                            this.tableDatayhs.map((item) => {
                                if (item.option.length == 0) {
                                    item.sfzim = true;
                                }
                            });
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        fordetail(row) {
            //该明显已被申报
            if (row.useType == 2) {
                return;
            }
            let id = row.id;
            detailssinglequery({
                id: id
            }).then((res) => {
                if (res.data.code == '1') {
                    this.formlist.forEach((item) => {
                        if (item.prop == 'jianmxzdmhxmmc') {
                            item.selectval.forEach((gtem) => {
                                gtem.label = gtem.ssjmxzhzDm + '   ' + gtem.swsxMc;
                                gtem.value = gtem.ssjmxzhzDm + '   ' + gtem.swsxMc;
                            });
                        }
                        if ((item.prop == 'zim' || item.prop == 'shuim') && this.formdata.shenbqxlx == '2') {
                            item.disabled = false;
                        }
                    });
                    this.tableDatadiag = res.data.data.dfslInfos;
                    this.tableDatasjs = res.data.data.jsxxInfos;
                    res.data.data.yingnse = Number(res.data.data.yingnse).toFixed(6);
                    res.data.data.jisje = Number(res.data.data.jisje).toFixed(2);
                    this.formdata = res.data.data;
                    delete this.formdata.dfslInfos;
                    delete this.formdata.jsxxInfos;
                    if (this.formdata.shenbqxlx != '0') {
                        this.disabledzimandshuim();
                    } else {
                        this.notdisabledzimandshuim();
                    }
                    this.geizimSelectval({
                        value: this.formdata.shuim
                    });
                    this.updatediag = true;
                }
            });
        },
        forupdate(index) {
            this.tableDatadiag[index].updated = true;
            let newarr = JSON.parse(JSON.stringify(this.tableDatadiag));
            this.tableDatadiag = newarr;
        },
        forfinish(index) {
            this.tableDatadiag[index].updated = false;
            let newarr = JSON.parse(JSON.stringify(this.tableDatadiag));
            this.tableDatadiag = newarr;
        },
        fordelete(index, taxval) {
            if (this.$notemptyandnull(taxval.id)) {
                this.delDfslIds.push(taxval.id);
            }
            this.tableDatadiag.splice(index, 1);
        },
        forSureUpdate() {
            this.$refs.taxform.submitForm();
        },
        getdata(formdata) {
            let params = JSON.parse(JSON.stringify(this.formdata));
            params.delDfslIds = this.delDfslIds;
            params.delJsxxIds = this.delJsxxIds;
            params.jsxxInfos = this.tableDatasj;
            params.dfslInfos = this.tableDatadiag.filter((item) => !item.updated);
            params.yhsId = this.mxparams.id;
            params.nsrsbh = this.mxparams.nsrsbh;
            console.log(!!this.formdata.id)
            if (!!this.formdata.id) {
                detailsupdate(params).then((res) => {
                    if (res.data.code == '1') {
                        this.updatediag = false;
                        this.$message.success(res.data.msg);
                        this.stampdetailsquery();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            } else {
                detailsadd(params).then((res) => {
                    if (res.data.code == '1') {
                        this.updatediag = false;
                        this.$message.success(res.data.msg);
                        this.stampdetailsquery();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });

            }
        },
        fordeleteall() {
            let selectVal = this.$refs.tableboxmain.getSelectionval();
            if (this.$emptyandnull(selectVal)) {
                this.$message.error('请选择要删除的数据');
                return false;
            }
            let isRight = selectVal.some((item) => item.useType == 2);
            if (isRight) {
                this.$message.error('已申报的数据不能删除');
                return false;
            }
            let params = {
                ids: selectVal.map((item) => item.id),
                yhsId: this.mxparams.id
            };
            detailsdelete(params).then((res) => {
                if (res.data.code == '1') {
                    this.$message.success(res.data.msg);
                    this.stampdetailsquery();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        fordeleteone(row) {
            //该明显已被申报
            if (row.useType == 2) {
                return;
            }
            let id = row.id;
            let params = {
                ids: [id],
                yhsId: this.mxparams.id
            };
            detailsdelete(params).then((res) => {
                if (res.data.code == '1') {
                    this.$message.success(res.data.msg);
                    this.stampdetailsquery();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        stampdetailsquery() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.yhsid = this.mxparams.id;
            params.nsrsbh = this.mxparams.nsrsbh;
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.suosq = this.suosq;
            if (this.searchdata.suosqq[1]) {
                params.suosqz = this.searchdata.suosqq[1].split(' ')[0];
                params.suosqq = this.searchdata.suosqq[0].split(' ')[0];
            } else {
                params.suosqq = '';
            }
            stampdetailsquery(params).then((res) => {
                if (res.data.code == '1') {
                    this.tableData = res.data.data.details;
                    this.pagination.total = res.data.data.total;
                    let newhead = JSON.parse(JSON.stringify(getdata().headData));
                    let titlelist = res.data.data.title;
                    titlelist.forEach((item, index) => {
                        if (item.title == '对方书立人涉及金额') {
                            item.width = 160;
                            item.AmountFormat = true;
                            item.align = 'right';
                        }
                        if ((index + 1) % 3 == 0) {
                            newhead.push({
                                title: '对立书立人信息',
                                children: [...[titlelist[index - 2]], ...[titlelist[index - 1]], ...[titlelist[index]]]
                            });
                        }
                    });
                    let selectval = [];
                    for (let key in res.data.data.shenblxDownList) {
                        selectval.push({
                            label: res.data.data.shenblxDownList[key],
                            value: key
                        });
                    }
                    this.formlist.forEach((item) => {
                        if (item.prop == 'shenbqxlx') {
                            item.selectval = selectval;
                        }
                    });
                    this.headData = newhead;
                    this.$nextTick(() => {
                        this.$refs.tableboxmain.dout();
                    });
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        //新增数据
        foradd() {
            Object.keys(this.formdata).map((key) => (this.formdata[key] = ''));
            this.formdata.shenbqxlx = '0';
            this.formdata.jianmse = '0';
            this.formdata.yijnse = '0';
            this.formdata.liuslfse = '0';
            this.formdata.yingbtse = '0';
            this.formlist.forEach((item) => {
                if (item.prop == 'jianmxzdmhxmmc') {
                    item.selectval.forEach((gtem) => {
                        gtem.label = gtem.ssjmxzhzDm + '   ' + gtem.swsxMc;
                        gtem.value = gtem.ssjmxzhzDm + '   ' + gtem.swsxMc;
                    });
                }
            });
            this.tableDatasj = [];
            this.notdisabledzimandshuim();
             this.tableDatadiag = [];
            this.updatediag = true;
                let time = new Date();
                let year = time.getFullYear();
                let month = time.getMonth() + 1;
                let day = time.getDate();
                this.formdata.suosqz = `${year}` + `${month > 9 ? month : '0' + month}` + `${day > 9 ? day : '0' + day}`;
                this.formdata.suosqq = `${year}` + `${month > 9 ? month : '0' + month}` + `${day > 9 ? day : '0' + day}`;
            ((this.delDfslIds = [])),
                (this.delJsxxIds = []);
           
            this.$nextTick(() => {
                this.$refs.taxform.clearValidate();
            });
        },
        foraddh() {
            this.tableDatadiag.push({
                updated: true
            });
        },
        forback() {
            this.$emit('forback', '');
        },
        stampdetailsshuimquery(val) {
            stampdetailsshuimquery({
                id: this.mxparams.id,
                nsrsbh: this.mxparams.nsrsbh,
                shenbqxlx: val
            }).then((res) => {
                this.tableDatasb = res.data.data;
                this.sbdiag = true;
                this.disabledzimandshuim();
            });
        },
        disabledzimandshuim() {
            this.formlist.forEach((item) => {
                if (item.prop == 'zim' || item.prop == 'shuim') {
                    item.disabled = true;
                }
            });
        },
        notdisabledzimandshuim() {
            this.formlist.forEach((item) => {
                if (item.prop == 'zim' || item.prop == 'shuim') {
                    item.disabled = false;
                }
            });
        },
        geizimSelectval(e) {
            let shuimlist = comMapping.$smzm;
            let zszm = [];
            let sllist = [];
            let sl1 = '';
            shuimlist.forEach((item) => {
                if (item.value == e.value) {
                    if (item.zszm.length == 0) {
                        this.formlist.map((item1) => {
                            if (item1.prop == 'zim') {
                                item1.disabled = true;
                            }
                        });
                    } else {
                        this.formlist.map((item1) => {
                            if (item1.prop == 'zim') {
                                item1.disabled = false;
                            }
                        });
                        zszm = item.zszm;
                    }

                    sllist = [
                        {
                            label: parseFloat(item.sl1 * 100) + '%',
                            value: item.sl1
                        }
                    ];
                    sl1 = item.sl1;
                }
            });
            this.formlist.forEach((item) => {
                if (item.prop == 'zim') {
                    item.selectval = zszm;
                }
                if (item.prop == 'shuil') {
                    item.selectVal = sllist;
                }
            });
            this.formdata.shuil = sl1;
        },
        zimchange(e) {
            let zimlist = [];
            let sllist = [];
            let sl1 = '';
            this.formlist.forEach((item) => {
                if (item.prop == 'zim') {
                    zimlist = item.selectval;
                }
            });
            zimlist.forEach((item) => {
                if (e.value == item.value) {
                    sllist = [
                        {
                            label: parseFloat(item.sl1 * 100) + '%',
                            value: item.sl1
                        }
                    ];
                    sl1 = item.sl1;
                }
            });
            this.formlist.forEach((item) => {
                if (item.prop == 'shuil') {
                    item.selectVal = sllist;
                }
            });
            this.formdata.shuil = sl1;
            this.amountyingnse();
            this.amountjianmse();
            this.amountyingbtse();
        },
        calculation() {},
        selectchange(e) {
            if (e.prop == 'shenbqxlx') {
                if (e.value == '0') {
                    this.sbtitle = '按次申报';
                    this.notdisabledzimandshuim();
                } else if (e.value == '2') {
                    this.sbtitle = '按季申报';
                    this.choosesb = null;
                    this.stampdetailsshuimquery(e.value);
                } else if (e.value == '4') {
                    this.sbtitle = '按年申报';
                    this.choosesb = null;
                    this.stampdetailsshuimquery(e.value);
                }
            }
            if (e.prop == 'shuim') {
                this.formdata.zim = '';
                this.geizimSelectval(e);
            }
            if (e.prop == 'zim') {
                this.zimchange(e);
            }
            if (e.prop == 'jianmxzdmhxmmc') {
                this.amountjianmse();
                this.amountyingbtse();
            }
            if (e.prop == 'shuil') {
                this.amountyingnse();
                this.amountjianmse();
                this.amountyingbtse();
            }
        },
        pickerchange(e) {
            if (e.prop == 'yingnspzsllsrq') {
                if (this.formdata.shenbqxlx == '2') {
                    let year = this.formdata.yingnspzsllsrq.substring(0, 4);
                    let season = Math.ceil(this.formdata.yingnspzsllsrq.substring(4, 6) / 3);
                    let endSeason = 3 * season;
                    let day = new Date(year, endSeason, 0).getDate();
                    if (endSeason < 10) {
                        endSeason = '0' + endSeason;
                    }
                    this.formdata.suosqz = year + endSeason + day;
                    this.formdata.suosqq = year + endSeason - 2 + '01';
                } else if (this.formdata.shenbqxlx == '4') {
                    let year = this.formdata.yingnspzsllsrq.substring(0, 4);
                    let day = new Date(year, 12, 0).getDate();
                    this.formdata.suosqz = year + '12' + day;
                    this.formdata.suosqq = year + '01' + '01';
                }
            }
        },
        foropensjdiag() {
            this.tableDatasj = this.tableDatasj.filter((item) => item.choosed);
            this.amountyingnse();
            this.total = 0;
            this.sjdiag = true;
        },
        addsjdiag() {
            this.tableDatasj.push({
                shijjsje: '0',
                shijjsrq: null
            });
        },
        deletesjdiag() {
            let selectVal = this.$refs.tableboxsj.getSelectionval();
            if (this.$emptyandnull(selectVal)) {
                this.$message.error('请选择要删除的数据');
                return false;
            }
            selectVal.forEach((item) => {
                if (this.$notemptyandnull(item.id)) {
                    this.delJsxxIds.push(item.id);
                }
            });
            this.tableDatasj = this.tableDatasj.filter((gtem) => !selectVal.includes(gtem));
            this.shijjsjeinput();
        },
        shijjsjeinput() {
            this.total = 0;
            this.tableDatasj.forEach((item) => {
                if (this.$notemptyandnull(item.shijjsje)) {
                    this.total += parseFloat(item.shijjsje);
                }
            });
        },
        forsuresj() {
            let state = false;
            if (this.$emptyandnull(this.tableDatasj)) {
                this.formdata.shijjsje = this.total;
                this.formdata.jisje = this.total;
                this.formdata.yingnse = 0;
                this.formdata.shijjsrq = null;
                this.sjdiag = false;
                return false;
            }
            this.tableDatasj.forEach((item) => {
                if (this.$emptyandnull(item.shijjsje) || this.$emptyandnull(item.shijjsrq)) {
                    state = true;
                }
            });
            if (state) {
                this.$message.error('必填项不能为空');
                return false;
            }
            let shijjsrqlist = [...new Set(this.tableDatasj.map((item) => item.shijjsrq))];
            if (shijjsrqlist.length == 1) {
                this.formdata.shijjsrq = shijjsrqlist[0];
            } else {
                this.formdata.shijjsrq = '';
            }
            this.shijjsjeinput();
            this.formdata.shijjsje = this.total;
            this.formdata.jisje = this.total;
            this.sjdiag = false;
            this.tableDatasj.forEach((item) => {
                item.choosed = true;
            });
        },
        amountjianmse() {
            if (this.$notemptyandnull(this.formdata.yingnse) && this.$notemptyandnull(this.formdata.jianmxzdmhxmmc)) {
                this.formdata.jianmse = this.formdata.yingnse.toFixed(2);
            }
        },
        amountyingnse() {
            if (this.$notemptyandnull(this.formdata.jisje) && this.$notemptyandnull(this.formdata.shuil)) {
                this.formdata.yingnse = `${this.formdata.jisje * this.formdata.shuil}`
            }
        },
        amountliuslfse() {
            if (this.mxparams.lflszc == 'Y') {
                this.formdata.liuslfse = ((this.formdata.yingnse - this.formdata.jianmse) / 2).toFixed(2);
            }else{
				 this.formdata.liuslfse='0.00';
			}
        },
        amountyingbtse() {
            this.formdata.yingbtse = (
                this.formdata.yingnse -
                this.formdata.jianmse -
                this.formdata.liuslfse -
                this.formdata.yijnse
            ).toFixed(2);
        },
        inputinput(e) {
            if(e.prop == 'yingnse') {
                this.amountjianmse();
                this.amountliuslfse();
                this.amountyingbtse();
            }
            if (e.prop == 'jisje') {
                
                this.amountyingnse();
                this.amountjianmse();
                this.amountliuslfse();
                this.amountyingbtse();
            }
            if (e.prop == 'jianmse') {
                this.amountliuslfse();
                this.amountyingbtse();
                this.amountjianmse();
            }
            if (e.prop == 'yijnse') {
                this.amountyingbtse();
            }
        },
        suosqbetweenquery(val) {
            suosqbetweenquery({
                suosq: this.mxparams.suosq,
                shenbqxlx: val
            }).then((res) => {
                if (this.formdata.yingnspzsllsrq) {
                    this.formdata.suosqz = res.data.data.end;
                    this.formdata.suosqq = res.data.data.begin;
                }
                this.sbdiag = false;
            });
        },
        forsuresbdiag() {
            if (this.$emptyandnull(this.choosesb)) {
                this.$message.error('请选择数据');
                return false;
            }
            this.formdata.shuim = this.choosesb.shuim;
            this.formdata.zim = '';
            this.geizimSelectval({
                value: this.formdata.shuim
            });
            this.formdata.zim = this.choosesb.zim;
            this.formdata.shuil = this.choosesb.shuil;
            this.amountyingnse();
            this.amountjianmse();
            this.suosqbetweenquery(this.formdata.shenbqxlx);
        }
    }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
